import React, { useState } from 'react';
import styled from 'styled-components';
import { PageWrapper } from '../../../CommonComponents/PageWrapper/PageWrapper';
import { RealizedGainLossTab } from './Components/RealizedGainLossTab/RealizedGainLossTab';
import { TransactionsTab } from './Components/TransactionsTab/TransactionTab';
import { SegmentedControl } from '../../../CommonComponents/OPL/SegmentedControl/SegmentedControl';
import { useOptions } from '../../hooks/useOptions';
import { useIsEmbeddedMobile } from '../../../_hooks/useIsEmbeddedMobile';
import { Box } from '../../../CommonComponents/OPL/Box/Box';
import { MobileHeader } from '../../components/MobileHeader/MobileHeader';
import { useFeatureFlag } from '../../../_hooks/useFeatureFlag';
import { Feature } from '../../../CommonSelectors/CommonArea.types';
import { PeriodSelector } from '../../components/PeriodSelector/PeriodSelector';

export const MobileWrapper = styled(Box)({
  marginBottom: 32,
});

const getTabMap = (showActivityDetails: boolean) => [
  {
    name: showActivityDetails ? 'Activity' : 'Transactions',
    component: TransactionsTab,
  },
  {
    name: 'Realized Gain/Loss',
    component: RealizedGainLossTab,
  },
];

interface Props {
  managedAccountId: string;
  selectedItemName: string;
  updatedAt: string;
}

const Transactions = ({ managedAccountId, selectedItemName, updatedAt }: Props) => {
  const isEmbeddedMobile = useIsEmbeddedMobile();

  const [currentTabIndex, setCurrentTabIndex] = useState(0);

  const showActivityDetails = useFeatureFlag(Feature.ActivityDetails);

  const tabMap = getTabMap(showActivityDetails);

  const { component: Component } = tabMap[currentTabIndex];
  const Wrapper = isEmbeddedMobile ? MobileWrapper : PageWrapper;

  const {
    transactionsSettings: { showCostBasis },
  } = useOptions();

  return (
    <Wrapper>
      {isEmbeddedMobile && (
        <Box mx="16" mb="12">
          <MobileHeader label={selectedItemName} subLabel={`Last updated: ${updatedAt}`} />
        </Box>
      )}

      {showCostBasis && (
        <SegmentedControl
          id="default"
          values={tabMap.map(({ name }) => name)}
          selectedIndex={currentTabIndex}
          onChange={setCurrentTabIndex}
          ariaLabel="Select transactions type"
          my="12"
          mx={isEmbeddedMobile ? '16' : 0}
        />
      )}

      {isEmbeddedMobile && (
        <Box px="16" mt="12">
          <PeriodSelector isVerticalLayout={isEmbeddedMobile} />
        </Box>
      )}

      <Component managedAccountId={managedAccountId} />
    </Wrapper>
  );
};

export default Transactions;
